import React, { useEffect, useState } from 'react';
import { Logo } from './Logo';
import { WhatsAppCta } from './WhatsAppCta';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-3' : 'bg-transparent py-4 md:py-5'}`} data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="flex justify-between items-center" data-id="element-30">
          <Logo light={!isScrolled} data-id="element-31" />

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-32">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`font-medium transition-colors ${isScrolled ? 'text-slate-600 hover:text-green-600' : 'text-white/90 hover:text-green-400'}`} data-id="element-33">
                {link.name}
              </a>)}
            <WhatsAppCta size="sm" text="Get a Quote" data-id="element-34" />
          </nav>

          {/* Mobile Menu Button */}
          <button className={`md:hidden p-2 transition-colors ${isScrolled ? 'text-slate-600' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-35">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-36" /> : <Menu className="w-6 h-6" data-id="element-37" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-slate-100 shadow-lg p-4 flex flex-col space-y-2" data-id="element-38">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-slate-700 font-medium py-3 px-4 hover:bg-slate-50 rounded-lg transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-39">
              {link.name}
            </a>)}
          <div className="pt-2" data-id="element-40">
            <WhatsAppCta className="w-full" text="Get a Quote" data-id="element-41" />
          </div>
        </div>}
    </header>;
}